<mat-sidenav-container class="mat-elevation-z1">
  <mat-sidenav #sidenav>
    <div class="d-flex justify-content-between align-items-center px-4 py-3 w-100">
      <div (click)="closeSideNav()" class="close">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </div>
      <a [routerLink]="'/'">
        <img class="nav-logo" src="/assets/images/logos/navbar-logo-design.png" alt="My Pool Hut Logo" />
      </a>
      <button mat-icon-button aria-label="Shopping Cart" class="cart" (click)="openDialog()">
        <mat-icon
          class="material-symbols-outlined"
          matBadgeColor="accent"
          matBadgeSize="small"
          [matBadge]="(cart$ | async)?.totalProducts"
          [matBadgeHidden]="(cart$ | async)?.lines?.length === 0 ? true : false"
          matTooltip="Cart"
        >
          shopping_bag
        </mat-icon>
      </button>
    </div>
    <mat-nav-list>
      <a mat-list-item routerLink="/pool-care">Pool Care</a>
      <a mat-list-item routerLink="/hot-tub-care">Hot Tub Care</a>
      <a mat-list-item routerLink="/clear-water-essentials">Clear Water Essentials</a>
      <a mat-list-item routerLink="/brands">Shop by Brand</a>
      <a mat-list-item routerLink="/orders">My Orders</a>
      <a mat-list-item routerLink="/blog">Learning Center</a>
      <a mat-list-item routerLink="/frequently-asked-questions">FAQs</a>
      <a mat-list-item routerLink="/about-us">About Us</a>
      <!-- <a mat-list-item (click)="sidenav.toggle()" href="" mat-list-item>Close</a> -->
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
